import React from 'react';

export type FeatureFlags = Partial<{
  'HelloSign_Prep_Send_Early_Next': boolean
  'Hellosign_Template_Preview': boolean
  'HelloFax_Optional_Editor': boolean
  'HelloSign_Rollout_Paginate_Signatures': boolean,
  'HelloSign_PrepAndSend_Next_Button_Bottom': boolean,
  'HelloSign_Request_Additional_Attachments': boolean
}>

const featureFlagContext = React.createContext<FeatureFlags>({});

type ProviderProps = {
  featureFlags: FeatureFlags,
  children: React.ReactNode
}

export function FeatureFlagProvider({ featureFlags, children }: ProviderProps) {
  return (
    <featureFlagContext.Provider value={featureFlags}>
      {children}
    </featureFlagContext.Provider>
  );
}

export function useFeatureFlag(name: keyof FeatureFlags) {
  const context = React.useContext(featureFlagContext);

  return Boolean(context[name]);
}

type FeatureFlagProps = {
  name: keyof FeatureFlags,
  value?: boolean,
  children: React.ReactNode,
}
export function FeatureFlag({ name, children, value = true }: FeatureFlagProps) {
  const enabled = useFeatureFlag(name);

  if (enabled === value) {
    return children;
  }
  return null;
}
